// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"e9d46a8f","403":"d9ef2f81","551":"2a37cce4","629":"a6fc9f5f","672":"e954b9de","842":"8df647c5"}[chunkId] + ".chunk.js";
};